import { render, staticRenderFns } from "./TablePresets.vue?vue&type=template&id=820df23c"
import script from "./TablePresets.vue?vue&type=script&lang=js"
export * from "./TablePresets.vue?vue&type=script&lang=js"
import style0 from "./TablePresets.vue?vue&type=style&index=0&id=820df23c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports